export const NAME_MAX_LENGTH = 50;
export const PHONE_MAX_LENGTH = 50;
export const EMAIL_MAX_LENGTH = 50;
export const ADDRESS_FIELD_MAX_LENGTH = 50;
export const NAME_REGEX = /^[a-zA-Zא-ת\s'-]*$/;
export const PHONE_REGEX = /^[0-9]*$/;
export const EMAIL_FORMAT_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Backend error code returned whenever the ticket could not be opened in Priority
export const TICKET_NOT_CREATED_ERROR = "TICKET_NOT_CREATED";
// Axios codes for a request that never got an answer - the ticket may not have been opened
export const NO_RESPONSE_ERROR_CODES = ["ERR_NETWORK", "ECONNABORTED"];

// Priority SOLUTIONCODE field: identifies whether the ticket was opened by scanning
// the device's QR code directly, or via the /device serial-number lookup page.
export const SOLUTION_CODE_QR_CODE = "007";
export const SOLUTION_CODE_DEVICE_PAGE = "008";

export const INITIAL_TICKET_FORM = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  text: "",
  urgency: "",
  callType: "",
  images: [],
  confirmAddress: false,
  confirmContactPerson: false,
  termsAccepted: false,
};

export const EMPTY_ADDRESS = { city: "", street: "", number: "", floor: "", room: "" };
export const EMPTY_CONTACT_ERRORS = { contactName: "", contactPhone: "", contactEmail: "" };
export const MAX_IMAGES = 5;

export const CALL_TYPE_OPTIONS = ["תקלה", "אחזקה מונעת"];
export const URGENCY_OPTIONS = ["לא דחוף", "דחוף", "מושבת"];

export const ADDRESS_FIELDS = [
  { key: "city", label: "עיר", isNumeric: false, required: true },
  { key: "street", label: "רחוב", isNumeric: false, required: true },
  { key: "number", label: "מספר", isNumeric: true, required: true },
  { key: "floor", label: "קומה", isNumeric: true, required: false },
  { key: "room", label: "חדר", isNumeric: true, required: false },
];
